document.addEventListener("DOMContentLoaded", function () {

  // ===== Tabs =====
  const tabs = document.querySelectorAll(".car-tab");
  const sections = document.querySelectorAll(".car-section");

  function activateTab(id) {
    tabs.forEach(t => t.classList.toggle("active", t.dataset.target === id));
  }

  tabs.forEach(tab => {
    tab.addEventListener("click", () => {
      const target = document.getElementById(tab.dataset.target);
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
        activateTab(tab.dataset.target);
        history.replaceState(null, "", "#" + tab.dataset.target);
      }
    });
  });

  if ("IntersectionObserver" in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          activateTab(e.target.id);
        }
      });
    }, { threshold: 0.33 });

    sections.forEach(sec => io.observe(sec));
  }

  // ===== Copy car code =====
  const copyBtn = document.getElementById("copy-code");
  if (copyBtn) {
    copyBtn.addEventListener("click", async () => {
      try {
        await navigator.clipboard.writeText(copyBtn.dataset.code);
        copyBtn.classList.add("success");
        copyBtn.textContent = "تم النسخ";
        setTimeout(() => {
          copyBtn.classList.remove("success");
          copyBtn.textContent = "نسخ الكود";
        }, 1200);
      } catch (e) {
        alert("تعذر نسخ الكود");
      }
    });
  }

});